export function data(state,data){
    state.data = data
}

export function disableForm(state,data){
    state.disableForm = data
}

export function bancos(state,bancos){
    state.bancos = bancos
}

export function pagination(state,pagination){
    state.pagination = pagination
}

export function limpaData(state){
    state.disableForm = false;
    // state.data = dataDefault;
    state.data = JSON.parse(JSON.stringify(state.dataDefault));    
    // state.id_banco_dados = '';
    // state.data = {
    //     id_banco_dados: '',
    //     descricao: '',
    //     nome: '',
    //     host: '',
    //     host_auxiliar: '',
    //     usuario: '',
    //     senha: '',
    //     tipo: '',
    // };
}